import React, { Component } from 'react'
import Modal from 'react-modal'
import PaymentAmountModalUI from './PaymentAmountModalUI.js'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'

class PaymentAmountModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,
            paidDate: '',
            paidDateError: null,
            amount: '',
            amountError: null,
        }
    }
    render() {
        return (
            <PaymentAmountModalUI
                context={this.props.context}
                successMsg={this.state.successMsg}
                errorList={this.state.errorList}
                onSubmit={this.onSubmit}
                onCancelClick={this.onCancelClick}
                updateMode={this.props.updateMode}
                // Fields
                paidDate={this.state.paidDate}
                onPaidDateChange={(dateISO) => this.setState({ paidDate: dateISO })}
                paidDateError={this.state.paidDateError}
                setPaidDateError={(error) => this.setState({ paidDateError: error })}
                amount={this.state.amount}
                onAmountChange={(event) => this.setState({ amount: event.target.value })}
                amountError={this.state.amountError}
                setAmountError={(error) => this.setState({ amountError: error })}
            />
        )
    }


    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        if (this.state.submitted) return

        this.setState({ submitted: true, successMsg: null, errorList: [] })

        RestApiUtils.put(this.props.context,
            `/api/su/test/loans/${this.props.loan.loanId}/scheduledDate/${this.props.selectedRepayment.scheduledDateISO}/chargeAmount/${this.props.selectedCharge.dateCreated}`,
            this.onSubmitCallback,
            {
                paidDateISO: this.state.paidDate,
                amountF: this.state.amount,
            }
        )
    }

    onSubmitCallback = (response) => {
        const errorList = response.errorList.map(error => error.message)

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null })
                this.onCancelClick()
                this.props.onRefreshClick('noBusy')
            }, 100)
        }
    }

    onCancelClick = () => {
        this.props.onCancelClick()
    }
}

export default PaymentAmountModalSF
